import type { TicketingOverviewPayload } from '../components/types';

export const TICKETING_OVERVIEW_MOCK: TicketingOverviewPayload = {
	overview: [
		{ key: 'total_tickets', title: 'Total Tickets', value: 1284, unit: 'count', trend: { value: 6.2, unit: 'percent', direction: 'up', impact: 'negative' }, description: 'vs prior period' },
		{ key: 'total_closed', title: 'Total Closed', value: 1082, unit: 'count', trend: { value: 4.8, unit: 'percent', direction: 'up', impact: 'positive' }, description: '84.3% of total tickets' },
		{ key: 'open_tickets', title: 'Open Tickets', value: 202, unit: 'count', trend: { value: 9.1, unit: 'percent', direction: 'up', impact: 'negative' }, description: '15.7% of total tickets' },
		{ key: 'critical_tickets', title: 'Critical Tickets', value: 38, unit: 'count', trend: { value: 12.5, unit: 'percent', direction: 'up', impact: 'positive' }, description: '14 currently open' },
		{ key: 'open_access_requests', title: 'Open Access Requests', value: 37, unit: 'count', trend: null, description: 'IDM Separation queue' },
		{ key: 'average_resolution_time', title: 'Average Resolution Time', value: 26.4, unit: 'hours', trend: { value: 8.3, unit: 'percent', direction: 'down', impact: 'positive' }, description: 'Closed (Merged) excluded' },
		{ key: 'average_time_new_in_progress', title: 'Average Time in New/In Progress', value: 16.7, unit: 'hours', trend: { value: 5.4, unit: 'percent', direction: 'down', impact: 'positive' }, description: 'Combined New + In Progress' },
		{ key: 'it_escalation_rate', title: 'IT Escalation Rate', value: 11.2, unit: 'percent', trend: { value: 2.1, unit: 'percent', direction: 'up', impact: 'negative' }, description: '144 tickets, Resolution Path: Requires IT' },
		{ key: 'ado_escalation_rate', title: 'ADO Escalation Rate', value: 6.8, unit: 'percent', trend: { value: 4.5, unit: 'percent', direction: 'up', impact: 'positive' }, description: '87 tickets reached Submitted to ADO' },
		{ key: 'duplicates_merged', title: 'Duplicates Merged', value: 23, unit: 'count', trend: { value: 9.5, unit: 'percent', direction: 'up', impact: null }, description: '56% of potential duplicates' },
	],
	statusBreakdown: [
		{ status: 'New', count: 38, description: 'Avg time in status: 2.1 hrs' },
		{ status: 'In Progress', count: 74, description: 'Avg time in status: 14.6 hrs' },
		{ status: 'Escalated to IT', count: 31, description: 'Avg time in status: 2.8 days' },
		{ status: 'Escalated to TMV', count: 9, description: 'Avg time in status: 4.1 days' },
		{ status: 'Submitted to ADO', count: 22, description: 'Avg time in status: 11.5 days' },
		{ status: 'Waiting on User', count: 28, description: 'Avg time in status: 2.3 days' },
		{ status: 'Closed', count: 1082, description: 'Avg resolution: 26.4 hrs' },
	],
	agingTickets: [
		{ bucket: '0 to 4 hours', count: 29, description: 'Open tickets in bucket' },
		{ bucket: '4 to 24 hours', count: 67, description: 'Open tickets in bucket' },
		{ bucket: '1 to 3 days', count: 58, description: 'Open tickets in bucket' },
		{ bucket: '3+ days', count: 48, description: 'Stale: no status change in 3+ days' },
	],
	ticketsByCategory: [
		{
			view: 'total',
			categories: [
				{ name: 'System Issue', count: 438, percentage: 34.1 },
				{ name: 'Reporting', count: 262, percentage: 20.4 },
				{ name: 'Access Request', count: 241, percentage: 18.8 },
				{ name: 'System Enhancement', count: 173, percentage: 13.5 },
				{ name: 'Training', count: 98, percentage: 7.6 },
				{ name: 'Hardware', count: 72, percentage: 5.6 },
			],
		},
		{
			view: 'open',
			categories: [
				{ name: 'System Issue', count: 92, percentage: 45.5 },
				{ name: 'Reporting', count: 41, percentage: 20.3 },
				{ name: 'Access Request', count: 37, percentage: 18.3 },
				{ name: 'System Enhancement', count: 16, percentage: 7.9 },
				{ name: 'Training', count: 12, percentage: 5.9 },
				{ name: 'Hardware', count: 4, percentage: 2.0 },
			],
		},
	],
	duplicateActivity: [
		{
			metric: 'Potential Duplicates',
			count: 41,
			percentage: null,
			description: 'Same Category and Sub-Category, open, within 24 hours',
		},
		{
			metric: 'Merged Tickets',
			count: 23,
			percentage: 56.1,
			description: 'of potential duplicates',
		},
		{
			metric: 'False Positives',
			count: 18,
			percentage: 43.9,
			description: 'Aged out or closed without merge',
		},
		{
			metric: 'Avg Time Between Dupes',
			value: 3.2,
			unit: 'hours',
			description: 'Between merged duplicate pairs',
		},
	],
};

